<template>
<div id="nav">
  <Header></Header>
  <router-view/>
  <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
body {
  height: 100%!important;
  width: 100%;
}

#app {
  width: 100%;
  height: 100%; 
  font-family: 'Helvetica Neue',Arial,Helvetica,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
}

#nav {
  height: 100%;
}

#nav a {
  font-weight: bold;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.ui.grid {
  margin: 0px!important;
}

.ui.menu {
  font-family: 'Helvetica Neue',Arial,Helvetica,sans-serif!important;
}

.access {
  text-align: center;
  width: 90%;
  height: 75%!important;
  margin: auto;
}

.swal2-icon{
  background-color:black!important;
  border: solid black!important;
} 

.swal2-error .swal2-x-mark-line-left, .swal2-x-mark-line-right{
  background-color:white!important;
}

.swal2-icon.swal2-info, .swal2-icon.swal2-warning {
  color:white!important
}

.swal2-styled.swal2-confirm, .swal2-styled.swal2-confirm:focus {
  background-color: #00f9a9 !important;
  border: solid #00f9a9!important;
  color: black!important;
  /* width: 145px!important; */
  width: 210px!important;
  box-shadow: unset!important;
}

.swal2-styled.swal2-cancel, .swal2-styled.swal2-deny {
  background-color: black !important;
  border: solid black!important;
  color: white!important;
  /* width: 145px!important; */
  width: 210px!important;
}
</style>
